if (!customElements.get("nss-ingredients-product-select")) {
    customElements.define("nss-ingredients-product-select", class NSSIngredientsProductSelect extends HTMLElement {
        constructor() {
            super();
            this.selectors = {
                productSelect: "[js-product-select]",
                productGroupSelect: "[js-product-group-select]",
                ingredientButton: "[js-ingredient-button]",
                productGroup: "[data-product-group]",
            };
            this.productSelects = [...this.querySelectorAll(this.selectors.productSelect)];
            this.productGroupSelects = [...this.querySelectorAll(this.selectors.productGroupSelect)];
            this.ingredientButtons = [...this.querySelectorAll(this.selectors.ingredientButton)];
            this.productGroups = [...this.querySelectorAll(this.selectors.productGroup)];
            this.selectedIndex = this.productSelect?.value || "1";
            this.selectedGroup = this.productGroups?.find(group => group.classList.contains('is--visible'))?.getAttribute('data-product-group');

            this.init();
        }

        init() {
            this.productSelects.forEach(select => {
                select.addEventListener("change", this.handleProductSelect.bind(this));
            });

            this.productGroupSelects.forEach(select => {
                select.addEventListener("change", this.handleGroupSelect.bind(this));
            });
        }

        handleProductSelect(e) {
            this.selectProduct(e.target.value);
        }

        handleGroupSelect(e) {
            this.selectGroup(e.target.value);
        }

        selectProduct(index) {
            const selectedButton = this.ingredientButtons.find(button => button.getAttribute('data-ingredient-button-index') == index);
            if (selectedButton) {
                this.selectedIndex = index;
                const otherButtons = this.ingredientButtons.filter(button => button != selectedButton);
                otherButtons.forEach(button => { button.classList.remove('is--visible') });
                selectedButton?.classList.add('is--visible');
            }
        }

        selectGroup(group) {
            const selectedProductGroup = this.productGroups.find(productGroup => productGroup.getAttribute('data-product-group') == group);
            if (selectedProductGroup) {
                const selectedGroupProductSelect = selectedProductGroup.querySelector(this.selectors.productSelect);
                if (selectedGroupProductSelect) {
                    this.selectedGroup = group;
                    const otherGroups = this.productGroups.filter(group => group != selectedProductGroup);
                    selectedProductGroup.classList.add('is--visible');
                    otherGroups.forEach(group => group.classList.remove('is--visible'));
                    this.selectProduct(selectedGroupProductSelect.value);
                }
            }
        }
    });
}